module.exports = __webpack_public_path__ + "static/media/order_alert.f9d53fb0.mp3";